import React, {
  useRef,
  useEffect,
  useState,
  forwardRef,
  useImperativeHandle,
  useMemo,
} from "react";
import SearchPanel from "../../../../../widgets/SearchPanel";
import { fnGetDataSet } from "@shared/api/restApi";
import { getInitFormData } from "@shared/utils/CommonUtils";
import SnGrid from "@shared/components/GridV2/SnGrid";
import { menuInfo } from "@shared/type/CommonType";

interface Props {
  Menuprops: menuInfo;
}

const SN_MTL_PRD_REP_002 = forwardRef(({ Menuprops }: Props, ref) => {
  const gridRefs = useRef<{ [key: string]: React.RefObject<any> }>({
    grid1: React.createRef(),
  });
  const searchRef = useRef<any>(null);
  const [formData, setFormData] = useState<any>();
  const [formControlData, setFormControlData] = useState<any[]>([]);
  const [columns, setColums] = useState<any>({
    grid1: [],
  });
  const [dataSources, setDataSources] = useState<any>({
    grid1: [],
  });

  useEffect(() => {
    const fetchform = async () => {
      try {
        const rtn: any = await getInitFormData({});
        setFormData(rtn.formData);
        setFormControlData(rtn.formControlData);
        setColums({
          grid1: rtn.grid.grid1,
        });
      } catch (error) {}
    };
    fetchform();
  }, []);

  const onSearch = async () => {
    try {
      const param = {
        id: "sn_mtl_prd_rep_002_01",
        params: searchRef.current.getFormdata(),
      };
      const data: any = await fnGetDataSet(param);
      setDataSources({
        grid1: data[0],
      });
    } catch (error: any) {}
  };

  useImperativeHandle(ref, () => ({
    onSearch,
  }));

  const grids = useMemo(
    () => ({
      grid1: {
        columns: columns.grid1,
        dataSource: dataSources.grid1,
      },
    }),
    [columns, dataSources]
  );

  return (
    <div className="h-full flex flex-col">
      <div>
        <SearchPanel
          ref={searchRef}
          data={formData}
          controls={formControlData}
        ></SearchPanel>
      </div>
      <div className="h-full flex flex-col">
        <SnGrid
          ref={gridRefs.current["grid1"]}
          columnConfig={grids.grid1.columns} // 컬럼 설정 전달
          rowData={grids.grid1.dataSource} // Datasource
          etcProps={{ rowSelection: "multiple" }}
          //chartColumns={["qt", "am"]}
        />
      </div>
    </div>
  );
});

export default SN_MTL_PRD_REP_002;
